export default function getHumanReadableLabel(machineReadableLabel: string): string | null {
  if (machineReadableLabel === "AMERICAN_COMPANY") {
    return "Stocks";
  }

  if (machineReadableLabel === "AMERICAN_REIT") {
    return "REITs";
  }

  if (machineReadableLabel === "BRAZILIAN_COMPANY") {
    return "Ações";
  }

  if (machineReadableLabel === "BRAZILIAN_REAL_ESTATE_FUND") {
    return "FIIs";
  }

  return null;
}
